// src/components/Common/NotificationModal.jsx
import React from "react";
import { Modal, ModalBody, Button } from "reactstrap";
import PropTypes from "prop-types";

const NotificationModal = ({
  isOpen,
  type,
  message,
  onClose = () => {},
  onConfirm = () => {},
  confirmButton,
  hasButtonCustom = false,
  titleCustom,
  children = null,
}) => {
  const config = {
    success: {
      color: "#4BB543",
      iconClass: "fas fa-check",
      text: "Sucesso!",
    },
    error: {
      color: "#EC221F",
      iconClass: "fas fa-times",
      text: "Erro!",
    },
    warning: {
      color: "#FECE22",
      iconClass: "fas fa-triangle-exclamation",
      text: "Atenção!",
    },
  }[type] || {
    color: "#6c757d",
    iconClass: "fas fa-info",
  };

  return (
    <Modal
      id="notification-modal"
      isOpen={isOpen}
      centered
      toggle={onClose}
      keyboard={false}
    >
      <ModalBody
        style={{ padding: "1.5rem" }}
        className="d-flex flex-column justify-content-center align-items-center"
      >
        <div className="form-group d-flex flex-column justify-content-center align-items-center">
          <div
            className="notification-div-icon"
            style={{ background: config.color }}
          >
            <i className={config.iconClass} />
          </div>

          {!!titleCustom && (
            <p className="text-center m-0 mb-3 ">
              <strong className="text-color-azul1 font-size-20 fw-semibold">
                {titleCustom}
              </strong>
            </p>
          )}
          {!titleCustom && (
            <p className="text-center m-0 mb-3">
              <strong className="text-color-azul1 font-size-20 fw-semibold">
                {config?.text}
              </strong>
            </p>
          )}

          <p className="text-center ">
            <small className="notification-msg mb-5 text-color-cinza4 font-size-15">
              {" "}
              {message}{" "}
            </small>
          </p>
          {children}
          {!hasButtonCustom && <>
            {confirmButton ? (
              <div className="d-flex gap-2 align-items-center">
                <button
                  onClick={onClose}
                  className="mx-2 btn border-0 px-4 p-3 fw-bold btn-cancelar-co0005"
                >
                  Cancelar
                </button>
                <button
                  onClick={onConfirm}
                  className="mx-2 btn btn-primary-dark border-0 px-4 p-3 fw-bold"
                >
                  Confirmar
                </button>
              </div>
            ) : (
              <button
                onClick={onClose}
                className="mx-2 btn btn-primary-dark border-0 px-4 p-3 fw-bold"
              >
                Ok!
              </button>
            )}
          </>}
        </div>
      </ModalBody>
    </Modal>
  );
};

export default NotificationModal;
